import React, { useState } from 'react';
import './Footer.css';
import { CommonObject } from '../CommonObject';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      // Handle newsletter subscription
      console.log('Subscribing email:', email);
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="pvg-footer">
      <div className="pvg-container">
        {/* Newsletter Section */}
        <div className="pvg-newsletter-section">
          <div className="pvg-newsletter-content">
            <div className="pvg-newsletter-text">
              <h4 className="pvg-newsletter-title">Stay Updated with <br/> <span className="pvg-newsletter-highlight">{CommonObject.CompanyName.PVG}</span></h4>
              <p className="pvg-newsletter-desc">Subscribe to our newsletter for the latest updates and insights</p>
            </div>
           
          </div>
        </div>

        <div className="pvg-content-grid">
          <div className="pvg-column pvg-company-column">
            <div className="pvg-company-info">
              <h3 className="pvg-column-title pvg-company-title">{CommonObject.CompanyName.PVG}</h3>
              <p className="pvg-company-desc">We help businesses grow faster with our innovative digital solutions and expert team. Connecting you to the services you need, when you need them.</p>
              <div className="pvg-social-icons">
                <a href="#" className="pvg-social-link" aria-label="Facebook">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="pvg-social-link" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#" className="pvg-social-link" aria-label="Instagram">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" className="pvg-social-link" aria-label="LinkedIn">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="#" className="pvg-social-link" aria-label="YouTube">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="pvg-column pvg-links-column">
            <h3 className="pvg-column-title">Quick Links</h3>
            <ul className="pvg-link-list">
              <li className="pvg-link-item"><a href="#home" className="pvg-nav-link">Home</a></li>
              <li className="pvg-link-item"><a href="#services" className="pvg-nav-link">Divisions</a></li>
              <li className="pvg-link-item"><a href="#solutions" className="pvg-nav-link">Solutions</a></li>
              <li className="pvg-link-item"><a href="#careers" className="pvg-nav-link">Careers</a></li>
            </ul>
          </div>
          
          <div className="pvg-column pvg-services-column">
            <h3 className="pvg-column-title">Our Services</h3>
            <ul className="pvg-link-list">
              <li className="pvg-link-item"><a href="/clickacook" className="pvg-nav-link">Click a Cook</a></li>
              <li className="pvg-link-item"><a href="#" className="pvg-nav-link">World Trade</a></li>
              <li className="pvg-link-item"><a href="#" className="pvg-nav-link">Training & Consultancy</a></li>
              <li className="pvg-link-item"><a href="#" className="pvg-nav-link">App Development</a></li>
              <li className="pvg-link-item"><a href="/IFMS_Home" className="pvg-nav-link">Integrated Facility Management</a></li>
            </ul>
          </div>
          
          <div className="pvg-column pvg-contact-column">
            <h3 className="pvg-column-title">Contact Us</h3>
            <div className="pvg-contact-info">
              <div className="pvg-contact-item">
                <i className="fas fa-map-marker-alt pvg-contact-icon"></i>
                <span>3 Hornton place, Kensington, London</span>
              </div>
              <div className="pvg-contact-item">
                <i className="fas fa-phone pvg-contact-icon"></i>
                <span>+1 (91) 72999-82022</span>
              </div>
              <div className="pvg-contact-item">
                <i className="fas fa-envelope pvg-contact-icon"></i>
                <span>hr@primeventuresglobal.com,</span>
                <span>support@primeventuresglobal.com</span>
                
              </div>
              <div className="pvg-contact-item">
                <i className="fas fa-clock pvg-contact-icon"></i>
                <span>Mon - Fri: 9:00 AM - 6:00 PM</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="pvg-copyright">
          <div className="pvg-copyright-content">
            <p className="pvg-copyright-text">
              &copy; 2024 {CommonObject.CompanyName.PVG}. All rights reserved.
            </p>
            <div className="pvg-legal-links">
              <a href="#" className="pvg-legal-link">Privacy Policy</a>
              <span className="pvg-legal-separator">|</span>
              <a href="#" className="pvg-legal-link">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button className="pvg-back-to-top" onClick={scrollToTop} aria-label="Back to top">
        <i className="fas fa-chevron-up pvg-back-icon"></i>
      </button>
    </footer>
  );
};

export default Footer;